import i18n from '../../../i18n';

export class Text {
  static get view(): string {
    return i18n._translate('View', {
      context: 'Call to action text next to an arrow icon indicating there is more to see upon clicking.',
    });
  }

  static get viewSeries(): string {
    return i18n._translate('View series', {
      context: 'Call to action text next to an arrow icon indicating there is more to see upon clicking.',
    });
  }
}
